import { render } from "./DownloadPage.vue?vue&type=template&id=879c8642"
import script from "./DownloadPage.vue?vue&type=script&lang=js"
export * from "./DownloadPage.vue?vue&type=script&lang=js"

import "./DownloadPage.vue?vue&type=style&index=0&id=879c8642&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__